import { supabase } from '@/integrations/supabase/client';

type ProductEventInput = {
  userId: string;
  eventName: string;
  path?: string;
  metadata?: Record<string, unknown>;
};

const SESSION_STORAGE_KEY = 'adulting_product_session_id';
const RECENT_EVENT_WINDOW_MS = 5_000;
const recentEventMap = new Map<string, number>();

function pruneRecentEvents() {
  const now = Date.now();
  for (const [key, value] of recentEventMap.entries()) {
    if (now - value > RECENT_EVENT_WINDOW_MS) {
      recentEventMap.delete(key);
    }
  }
}

function buildFingerprint(input: ProductEventInput) {
  return [
    input.userId,
    input.eventName,
    input.path || '',
    JSON.stringify(input.metadata || {}),
  ].join('::');
}

function getSessionId() {
  if (typeof window === 'undefined') return null;

  const existing = window.sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (existing) return existing;

  const next = crypto.randomUUID();
  window.sessionStorage.setItem(SESSION_STORAGE_KEY, next);
  return next;
}

export async function trackProductEvent(input: ProductEventInput) {
  if (!input.userId || !input.eventName.trim()) return;

  pruneRecentEvents();
  const fingerprint = buildFingerprint(input);
  if (recentEventMap.has(fingerprint)) return;
  recentEventMap.set(fingerprint, Date.now());

  try {
    await supabase.from('product_events' as any).insert({
      user_id: input.userId,
      session_id: getSessionId(),
      event_name: input.eventName.trim(),
      path: input.path || null,
      metadata: {
        surface: 'web',
        ...(input.metadata || {}),
      },
    });
  } catch (error) {
    console.error('Product analytics event logging failed', error);
  }
}
